import { mapActions, mapGetters } from 'vuex';
import StudentIdentificationSubmitted from '../widgets/StudentIdentificationSubmitted';
import StudentIdentificationUnapproved from '../widgets/StudentIdentificationUnapproved';
export default {
  name: 'StudentIdentification',
  props: {
    logo: {
      type: String,
      default: null
    },
    projectId: {
      type: Number,
      required: true
    }
  },
  created() {
    this.fetch({
      projectID: this.projectId
    });
  },
  methods: {
    ...mapActions('subjectids', ['fetch']),
    onFetch() {
      window.location.reload();
    }
  },
  computed: {
    ...mapGetters('subjectids', ['unapprovedItems', 'submittedItems', 'errors'])
  },
  components: {
    StudentIdentificationSubmitted,
    StudentIdentificationUnapproved
  }
};